import React from 'react';
import { ROUTES } from 'shared/constants/routes';
import SubHeader from 'components/SubHeader';
import ProductSection from 'pages/my-stores/products/ProductSection';
import { Container } from 'styles/pages/my-stores/products';

const Products = () => {
  return (
    <>
      <SubHeader
        title='Browse'
        links={[
          {
            title: ROUTES.HOME.TITLE,
            to: ROUTES.HOME.LINK,
          },
        ]}
        currentPageTitle='Products'
      />
      <Container>
        {/* <FiltersWrapper>
          <Filter>
            <h4>Filter by Marketplace</h4>
            <div>
              <FilterButton>Etsy</FilterButton>
              <FilterButton>Shipstation</FilterButton>
              <FilterButton>Shopify</FilterButton>
              <FilterButton>All</FilterButton>
            </div>
          </Filter>
          <SearchWrapper>
            <Clear>Clear</Clear>
            <SearchBar />
          </SearchWrapper>
        </FiltersWrapper> */}
        <ProductSection />
      </Container>
    </>
  );
};

export default Products;
